import { $ } from '@/Engine/state';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { Part } from '@/Engine/Part';
import { smallCasePrototypeIds } from '@/Constants/caseComponentsLib/caseComponentsLib';

export function deleteSelectedModel(model = $.selectedModel) {
    if (!$.toolChest || !model) return;

    const instanceModel = model.userData.parent;
    instanceModel.childrenAccessory.forEach((x: Part) => {
        //удаляем аксессуары для экрана
        deleteSelectedModel(x.model);
    });

    if (instanceModel.key.includes('separator')) {
    //удаляем комплектующие без перегородки
        $.toolChest.parts
            .filter(x => smallCasePrototypeIds.includes(x.prototypeId) || x.prototypeId === 'niches_tc_1995')
            .forEach(x => deleteSelectedModel(x.model));
    }

    if (instanceModel.key === 'shelfCNCHard') {
        instanceModel.deleteChildren();
    }
    $.toolChest.removeComponent(instanceModel);
    useStoreCaseConfiguration().$patch({ caseItems: $.toolChest.raw.caseItems });
}